import React from 'react';

export type ActiveListView = 'active' | 'all';

export interface ActiveListViewContextValue {
  view: ActiveListView;
  activeTitle: React.ReactNode;
  allTitle: React.ReactNode;
  onViewChange: (view: ActiveListView) => void;
}

export const ActiveListViewContext = React.createContext<ActiveListViewContextValue | undefined>(undefined);
